// 横向滑动
const drag = {
  inserted: function (el) {
    el.onmousedown = function(event) {
      let gapX = event.clientX;
      let startX = el.scrollLeft;
      document.onmousemove = function(e) {
          let x = e.clientX - gapX;
          el.scrollLeft = startX - x;
          return false;
      };
      document.onmouseup = function(e) {
          document.onmousemove = null;
          document.onmouseup = null;
      };
    };
  }
}
export default drag


// WEBPACK FOOTER //
// ./src/digitalHuman/directives/drag.js